import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { NoteViewModel, NoteAttachment } from '../../models/note.model';
import { NotesService } from '../..//services/notes.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-note-card',
  templateUrl: './note-card.component.html',
  styleUrls: ['./note-card.component.scss'],
})
export class NoteCardComponent implements OnInit {
  @Input() note: NoteViewModel;
  @Input() isSelected: boolean = false;
  @Input() isTrashView: boolean = false;
  @Input() canEdit: boolean = true;

  @Output() noteEdit = new EventEmitter<NoteViewModel>();
  @Output() noteDelete = new EventEmitter<string>();
  @Output() notePinToggle = new EventEmitter<string>();
  @Output() noteArchiveToggle = new EventEmitter<string>();
  @Output() noteRestore = new EventEmitter<string>();
  @Output() notePermDelete = new EventEmitter<string>();

  tags: string[] = [];
  //isTrashView: boolean = false;
  showActions: boolean = false;
  reminderFormatted: string = '';
  showAttachmentModal: boolean = false;
  currentAttachment: NoteAttachment | null = null;

  constructor(
    private notesService: NotesService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.tags = this.notesService.parseTags(this.note.Tags);
    //this.isTrashView = this.note.IsTrashed;
    if (this.note.HasReminder && this.note.ReminderDate) {
      const d = new Date(this.note.ReminderDate);
      this.reminderFormatted = d.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    }
  }

  getSafeUrl(att: NoteAttachment): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.getAttachmentUrl(att));
  }

  get isReminderOverdue(): boolean {
    if (!this.note.HasReminder || !this.note.ReminderDate) return false;
    return new Date(this.note.ReminderDate) < new Date();
  }

  onCardClick(): void {
    //alert('card clicked canEdit=' + this.canEdit);
    console.log('CLICK:', this.canEdit, this.note.CreatedBy);
    console.log('--- card clicked ---')
    if (!this.isTrashView && this.canEdit) {
      console.log('Emitting edit event for note:', this.note.NoteId);
      this.noteEdit.emit(this.note);
    } else {
      console.log('Edit prevented - conditions not met');
    }
  }

  togglePin(event: Event): void {
    event.stopPropagation();
    this.notePinToggle.emit(this.note.NoteId);
  }

  toggleArchive(event: Event): void {
    event.stopPropagation();
    this.noteArchiveToggle.emit(this.note.NoteId);
  }

  handleDelete(event: Event): void {
    event.stopPropagation();
    this.noteDelete.emit(this.note.NoteId);
  }

  handleRestore(event: Event): void {
    event.stopPropagation();
    this.noteRestore.emit(this.note.NoteId);
  }

  permanentDelete(event: Event): void {
    event.stopPropagation();
    this.notePermDelete.emit(this.note.NoteId);
  }

  getAttachmentCount(): number {
    return this.note.Attachments ? this.note.Attachments.length : 0;
  }

  getMentionCount(): number {
    return this.note.Mentions ? this.note.Mentions.length : 0;
  }

  truncateContent(content: string, limit: number = 120): string {
    if (!content) return '';
    return content.length > limit ? content.substring(0, limit) + '...' : content;
  }

  getFileIconType(fileType: string): string {
    if (!fileType) return 'default';

    const type = fileType.toLowerCase();

    if (type.includes('image')) return 'image';
    if (type.includes('pdf')) return 'pdf';
    if (type.includes('excel') || type.includes('spreadsheet')) return 'excel';
    if (type.includes('word')) return 'word';
    if (type.includes('text')) return 'text';
    if (type.includes('zip') || type.includes('rar')) return 'archive';

    return 'default';
  }

  // private resolveUrl(fileUrl: string): string {
  //   if (!fileUrl) return '';
  //   if (fileUrl.startsWith('http')) return fileUrl;
  //   return `${environment.apiUrl}${fileUrl}`;
  // }

  private getAttachmentUrl(att: NoteAttachment): string {

    if (att.FileURL.startsWith('api/')) {
      return `${environment.apiUrl}${att.FileURL}`;
    }

    return `${environment.apiUrl}api/Notes/GetAttachment?noteId=${this.note.NoteId}&fileName=${att.FileURL}`;
  }

  viewAttachment(att: NoteAttachment): void {
    const url = this.getAttachmentUrl(att);

    const type = (att.FileType || '').toLowerCase();

    if (type.startsWith('image/') || type.includes('pdf')) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      this.downloadAttachment(att);
    }
  }

  downloadAttachment(att: NoteAttachment): void {
    const url = this.getAttachmentUrl(att);

    const link = document.createElement('a');
    link.href = url;
    link.download = att.FileURL;
    link.target = '_blank';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
